import { EnvironmentModel } from './environment.model';

export const environment: EnvironmentModel = {
  apiBaseUrl: 'https://dev.portfolio.flexsoft.dev/api/v1',
};
